import { Card, Icon } from '@toggle/design-system';
import { intlFormat } from 'date-fns';
import { useTranslation } from 'next-i18next';
import React from 'react';

import * as S from './EarningsDate.styles';

export interface EarningsDateProps {
  reporting_date: string;
  reported: boolean;
  locale: string;
}

export const EarningsDate = ({
  reporting_date,
  reported,
  locale,
}: EarningsDateProps) => {
  const reportingDate = new Date(reporting_date);
  const { t } = useTranslation('earnings');

  const hourFormatted = intlFormat(
    reportingDate,
    {
      hour: 'numeric',
      minute: 'numeric',
    },
    {
      locale,
    }
  );

  const dateFormatted = intlFormat(
    reportingDate,
    {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
    },
    {
      locale,
    }
  );

  return (
    <S.EarningsDateRoot data-testid="earnings-date">
      <Card size="small">
        <S.Title isReported={reported}>
          <Icon
            iconName={reported ? 'CheckmarkLightCircle' : 'Calendar'}
            size={16}
          />
          {reported ? (
            <span data-testid="after-publication">
              {t('earnings:earningsPublished')}
            </span>
          ) : (
            <span data-testid="before-publication" suppressHydrationWarning>
              {t('earnings:earningsBeforePublication', {
                hourFormatted,
              })}
            </span>
          )}
        </S.Title>
        <S.Description suppressHydrationWarning>{dateFormatted}</S.Description>
      </Card>
    </S.EarningsDateRoot>
  );
};
